<div class="row">
    <div class="col">
      @if(showBackButton){
        <h4 class="fs-6 d-flex gap-2 mb-3 align-items-center">
          Elige entre: {{policies.length}} pólizas para iniciar
        </h4>
      }
        <div class="form-group">
            <input (input)="handleSearch()" [(ngModel)]="searchFilter" class="form-control form-control-sm focus-ring focus-ring-light border" placeholder="Buscar póliza" />
        </div>
        <div class="policy-list bg-light p-2 d-flex flex-column gap-2 mt-3 rounded-4">
          @for (policy of filteredPolicies; track $index) {
          @let pendingBalance = redirectToPaymentOnPending ? findPendingBalance(policy) : undefined;
          <div (click)="selectPolicy(policy, $index)" [ngClass]="{'policy-selected': $index === indexSelected}" class="card shadow-sm rounded-3 p-3 selectable-policy-item" style="cursor: pointer;">
              <div class="d-flex align-items-center gap-1 my-1">
                  <span><strong class="text-colonial">{{policy.product.description}}</strong></span>
              </div>
              <div class="d-flex align-items-center gap-3">
                  <span>{{policy.policyNumber | mask: policyMask}}</span>
                  <span class="small text-muted text-uppercase">{{policy.expirationDate | date: dateFormats.ddMMyyyy }}</span>
              </div>
              <div class="d-flex align-items-center gap-1 mt-1">
                  <span class="material-symbols-outlined fw-light text-colonial">id_card</span>
                  <span class="small">{{policy.debtorName}}</span>
              </div>
              @if (pendingBalance) {
                <div class="mt-2">
                  <span class="badge rounded-pill text-bg-danger d-inline-flex align-items-center gap-1 px-2 py-1">
                    <span class="material-symbols-outlined" style="font-size: 14px;">error</span>
                    Pendiente de pago: {{pendingBalance.currency}} ${{pendingBalance.amount | number: '1.2-2'}}
                  </span>
                </div>
              }
          </div>
          } @empty {
          <div class="d-flex justify-content-center p-2">Sin pólizas</div>
          }
        </div>
    </div>
</div>
@if(showBackButton){
  <div class="row">
    <div class="d-flex my-2 align-items-center justify-content-start">
      <button (click)="goBack()" class="btn btn-outline-dark border">
        Regresar
      </button>
    </div>
  </div>
}
